import { render, staticRenderFns } from "./ProformaView.vue?vue&type=template&id=064f2544&"
import script from "./ProformaView.vue?vue&type=script&lang=js&"
export * from "./ProformaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports